export class Usuario {
    id: number;
    cuenta: string;
    password: string;
    rol: string;
    idiomas = [];
    token: string;
}



// WEBPACK FOOTER //
// ./src/app/usuarios/domain/usuario.ts